import VueRouter from "vue-router";
import MainView from "@view/home";
import OutpatientView from "@view/home/outpatient";
import InpatientView from "@view/home/inpatient";
import PersonCenterView from "@view/home/person-center";

const routes = [
  // 主页模块
  {
    name: "home",
    path: "/",
    component: MainView,
    redirect: "/home",
    meta: {
      title: "首页",
      keepAlive: false
    },
    children: [
      {
        path: "/home",
        name: "outpatient",
        component: OutpatientView,
        meta: {
          title: "门诊",
          keepAlive: true
        }
      },
      {
        path: "/inpatient",
        name: "inpatient",
        meta: {
          title: "住院",
          keepAlive: true
        },
        component: InpatientView
      },
      {
        path: "/examination",
        name: "examination",
        meta: {
          title: "体检",
          keepAlive: true
        },
        component: () => import("@view/home/examination")
      },
      {
        path: "/mine",
        name: "mine",
        meta: {
          title: "个人中心",
          keepAlive: true
        },
        component: PersonCenterView
      }
    ]
  },
  // 预约模块
  {
    path: "/appointment",
    meta: {
      title: "预约模块"
    }
  },
  {
    name: "hospital-introduction",
    path: "/reference/hospital/introduce",
    meta: {
      title: "医院介绍"
    },
    component: () => import("@view/hospital/introduce")
  },
  {
    name: "hospital-navigate",
    path: "/reference/hospital/navigate",
    meta: {
      title: "医院导航"
    },
    component: () => import("@view/hospital/navigation")
  },
  {
    name: "expert-introduction",
    path: "/reference/experts/introduce",
    meta: {
      title: "专家介绍"
    },
    component: () => import("@view/hospital/expert-introduction")
  },
  {
    name: "department-introduction",
    path: "/reference/department/introduce",
    meta: {
      title: "科室介绍"
    },
    component: () => import("@view/hospital/department/introduce")
  },
  {
    name: "department-introduction-detail",
    path: "/reference/department/detail",
    meta: {
      title: "科室介绍明细"
    },
    component: () => import("@view/hospital/department/detail")
  },
  // {
  //   name: "floor-index",
  //   path: "/reference/hospital/index",
  //   meta: {
  //     title: "楼层索引"
  //   },
  //   component: () => import("@view/ClinicGuideViews/FloorIndexView")
  // },
  {
    name: "floor-index",
    path: "/other/floor",
    meta: {
      title: "楼层索引"
    },
    component: () => import("@view/other/floor")
  },
  {
    name: "price-query",
    path: "/reference/price/query",
    meta: {
      title: "价目查询"
    },
    component: () => import("@view/hospital/pricequeryView")
  },
  {
    name: "recharge",
    path: "/payment/recharge",
    meta: {
      title: "充值缴费"
    },
    component: () => import("@view/user/payment")
  },
  {
    name: "recharge-record",
    path: "/payment/recharge/record",
    meta: {
      title: "充值记录"
    },
    component: () => import("@view/user/record/payment")
  },
  {
    name: "inspectionlist-reports",
    path: "/reports/inspectionlist",
    meta: {
      title: "检验报告"
    },
    component: () => import("@view/user/report/inspection/list")
  },
  {
    name: "inspection-reports-detail",
    path: "/reports/inspectiondetail",
    meta: {
      title: "检验报告"
    },
    component: () => import("@view/user/report/inspection/detail")
  },
  {
    name: "medical-imaging-list",
    path: "/reports/medicalimaginglist",
    meta: {
      title: "医疗影像"
    },
    component: () => import("@view/user/report/screenage/list")
  },
  {
    name: "medical-imaging-detail",
    path: "/reports/medicalimagingdetail",
    meta: {
      title: "医疗影像"
    },
    component: () => import("@view/user/report/screenage/detail")
  },
  {
    name: "attention-list",
    path: "/reference/attentions",
    meta: {
      title: "注意事项"
    },
    component: () => import("@view/hospital/attention")
  },
  {
    name: "outpatient-guide",
    path: "/reference/outpatient/guide",
    meta: {
      title: "门诊指南"
    },
    component: () => import("@view/hospital/outpatientguide")
  },
  {
    name: "healthy-list",
    path: "/reference/healthy/list",
    meta: {
      title: "健康百科"
    },
    component: () => import("@view/hospital/healthy")
  },
  {
    name: "healthy-detail",
    path: "/reference/healthy/detail",
    meta: {
      title: "健康百科明细"
    },
    component: () => import("@view/hospital/healthydetail")
  },
  {
    name: "news-list",
    path: "/reference/news/list",
    meta: {
      title: "新闻公告"
    },
    component: () => import("@view/hospital/news")
  },
  {
    name: "medical-report-login",
    path: "/reports/medicalreportloginView",
    meta: {
      title: "体检报告登录"
    },
    component: () => import("@view/user/report/medicalreportloginView")
  },
  {
    name: "daily-reports-list",
    path: "/reports/dailylist",
    meta: {
      title: "门诊清单"
    },
    component: () => import("@view/user/report/dailylist")
  },
  // 卡包
  {
    name: "change-card",
    path: "/user/components/changecardview",
    meta: {
      title: "我的卡包"
    },
    component: () => import("@view/user/cardpackage")
  },
  {
    name: "waiting-inline",
    path: "/clinicguideviews/waitinginline",
    meta: {
      title: "排队候诊"
    },
    component: () => import("@view/user/waiting")
  },
  {
    name: "medication-remind",
    path: "/clinicguideviews/medicationremind",
    meta: {
      title: "用药提醒"
    },
    component: () => import("@view/user/remind")
  },
  // 选择科室列表
  {
    name: "department-list",
    path: "/appointment/departments",
    meta: {
      title: "预约科室列表",
      keepAlive: true
    },
    component: () => import("@view/appointment/type")
  },
  // 选择二级科室列表
  {
    name: "secondary-department-list",
    path: "/appointment/secondarydepartments",
    meta: {
      title: "预约科室列表",
      keepAlive: true
    },
    component: () => import("@view/appointment/type/secondarydepartment")
  },
  // 预约医生列表
  {
    name: "appointment-schedule-department",
    path: "/appointment/departments/dortorlistview",
    meta: {
      title: "医生列表"
    },
    component: () => import("@view/appointment/schedule/department")
  },
  // 按医生预约号源列表
  {
    name: "appointment-schedule-doctor",
    path: "/appointment/schedule/doctor",
    meta: {
      title: "医生列表"
    },
    component: () => import("@view/appointment/schedule/doctor")
  },
  {
    name: "appointment-record",
    path: "/appointment/departments/appointmentrecordview",
    meta: {
      title: "预约记录"
    },
    component: () => import("@view/user/record/appointment")
  },
  {
    name: "appointment-registration",
    path: "/appointment/registration",
    meta: {
      title: "预约登记"
    },
    component: () => import("@view/appointment/registration")
  },
  {
    name: "relative-card",
    path: "/users/bind/card",
    meta: {
      title: "绑定卡片"
    },
    component: () => import("@view/user/bindcard")
  },
  // 核酸用户建档
  {
    name: "nucleic-acid-user-building",
    path: "/other/nat/building",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/building")
  },
  {
    name: "relative-phone",
    path: "/user/setting/phone",
    meta: {
      title: "绑定手机号"
    },
    component: () => import("@view/user/setting/phone")
  },
  {
    name: "modify-archive",
    path: "/users/archive/modify",
    meta: {
      title: "修改建档信息"
    },
    component: () => import("@view/user/archivemodify")
  },
  {
    name: "disclaimer",
    path: "/reference/disclaimer",
    meta: {
      title: "免责声明"
    },
    component: () => import("@view/hospital/disclaimer")
  },
  {
    name: "privacy-agreement",
    path: "/reference/privacy/agreement",
    meta: {
      title: "隐私协议"
    },
    component: () => import("@view/hospital/privacy")
  },
  {
    name: "error-page",
    path: "/reference/page/error",
    meta: {
      title: "页面加载失败"
    },
    component: () => import("@view/hospital/error")
  },
  {
    name: "drug-introduce",
    path: "/reference/drug/introduce",
    meta: {
      title: "药品说明"
    },
    component: () => import("@view/hospital/drugintroduce")
  },
  {
    name: "hospital-image",
    path: "/reference/hospital/image",
    meta: {
      title: "院区平面图"
    },
    component: () => import("@view/hospital/floorplan")
  },
  {
    name: "about-us",
    path: "/reference/about",
    meta: {
      title: "关于我们"
    },
    component: () => import("@view/hospital/about")
  },
  {
    name: "doctor-detail",
    path: "/reference/doctor/detail",
    meta: {
      title: "医生简介"
    },
    component: () => import("@view/appointment/doctorinfo")
  },
  {
    name: "satisfaction-outpatient",
    path: "/other/satisfaction/outpatient",
    meta: {
      title: "门诊满意度调查"
    },
    component: () => import("@view/other/satisfaction")
  },
  {
    name: "feed-back",
    path: "/other/feedback",
    meta: {
      title: "意见反馈"
    },
    component: () => import("@view/other/feedback")
  },
  // 药品制剂列表
  {
    name: "drug-intruction-list",
    path: "/other/drugintruction/list",
    meta: {
      title: "药品制剂列表",
      keepAlive: true
    },
    component: () => import("@view/other/drugintruction/list")
  },
  // 药品制剂明细
  {
    name: "drug-intruction-detail",
    path: "/other/drugintruction/detail",
    meta: {
      title: "药品制剂明细"
    },
    component: () => import("@view/other/drugintruction/detail")
  },
  // 核酸用户信息
  {
    name: "nucleic-acid-user-info",
    path: "/other/nat/userinfo",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/userinfo")
  },
  // 核酸检测开单
  {
    name: "nucleic-acid-test",
    path: "/other/nat",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/index")
  },
  // 核酸开单查询首页
  {
    name: "nucleic-record-login",
    path: "/other/nat/record/login",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/loginrecord")
  },
  // 核酸开单查询列表
  {
    name: "nucleic-record-list",
    path: "/other/nat/record/list",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/recordlist")
  },
  // 核酸开单查询列表详情
  {
    name: "nucleic-record-detail",
    path: "/other/nat/record/detail",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/recorddetail")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("@view/other/404")
  },
  {
    name: "vaccine",
    path: "/vaccine/index",
    meta: {
      title: "疫苗预约"
    },
    component: () => import("@view/other/vaccine/index")
  },
  {
    name: "vaccine-form",
    path: "/vaccine/form",
    meta: {
      title: "预约登记"
    },
    component: () => import("@view/other/vaccine/form")
  },
  {
    name: "vaccine-record",
    path: "/vaccine/record",
    meta: {
      title: "预约记录"
    },
    component: () => import("@view/other/vaccine/record")
  },
  {
    name: "medical-report-index",
    path: "/other/medicalreport/index",
    meta: {
      title: "体检报告"
    },
    component: () => import("@view/other/medicalreport/login")
  },
  {
    name: "medical-report-list",
    path: "/other/medicalreport/list",
    meta: {
      title: "体检报告列表"
    },
    component: () => import("@view/other/medicalreport/list")
  },
  {
    name: "medical-report-detail",
    path: "/other/medicalreport/detail",
    meta: {
      title: "体检报告详情"
    },
    component: () => import("@view/other/medicalreport/detail")
  },
  // 核酸检测开单首页
  {
    name: "nucleic-acid-test-home",
    path: "/other/nat",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/index")
  },
  // 核酸检测开单信息采集
  {
    name: "nucleic-acid-test-nat",
    path: "/other/nat/nat",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/nat")
  },
  // 核酸检测开单记录
  {
    name: "nucleic-acid-test-record",
    path: "/other/nat/record",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/record")
  },
  // 核酸检测开单报告列表
  {
    name: "nucleic-acid-test-report-list",
    path: "/other/nat/record",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/record")
  },
  // 核酸检测开单报告明细
  {
    name: "nucleic-acid-test-report-detail",
    path: "/other/nat/report/detail",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat/reportdetail")
  },
  {
    name: "nucleic-acid-test",
    path: "/other/nat/register",
    meta: {
      title: "核酸检测开单"
    },
    component: () => import("@view/other/nat")
  },
  // 推送设置登录
  {
    name: "push-setting-login",
    path: "/other/pushsetting/login",
    meta: {
      title: "推送设置"
    },
    component: () => import("@view/other/pushsetting/login")
  },
  // 推送设置
  {
    name: "push-setting",
    path: "/other/push/setting",
    meta: {
      title: "推送设置"
    },
    component: () => import("@view/other/pushsetting/setting")
  },
  // 推送设置列表
  {
    name: "push-list",
    path: "/other/push/list",
    meta: {
      title: "推送设置"
    },
    component: () => import("@view/other/pushsetting/list")
  },

  {
    name: "escortpeople-list",
    path: "/escortpeople/list",
    meta: {
      title: "住院陪护凭证"
    },
    component: () => import("@view/other/escortpeople")
  },
  {
    name: "escortpeople-add",
    path: "/escortpeople/add",
    meta: {
      title: "添加陪护人"
    },
    component: () => import("@view/other/escortpeople/addescortpeople")
  },
  {
    name: "escortpeople-survey",
    path: "/escortpeople/survey",
    meta: {
      title: "添加陪护人"
    },
    component: () => import("@view/other/escortpeople/survey")
  },
  {
    name: "other-suspensionNotice",
    path: "/other/suspensionNotice",
    meta: {
      title: "停诊通知"
    },
    component: () => import("@view/other/suspensionNotice")
  },
  {
    name: "onlineRefund",
    path: "/onlineRefund",
    meta: {
      title: "在线退款"
    },
    component: () => import("@view/onlineRefund")
  },
  {
    name: "onlineRefundNoVerify",
    path: "/onlineRefundNoVerify",
    meta: {
      title: "在线退款（免验证码）"
    },
    component: () => import("@view/onlineRefund/noVerify")
  },
  {
    name: "onlineRefundQuery",
    path: "/onlineRefundQuery",
    meta: {
      title: "院内预留手机查询"
    },
    component: () => import("@view/onlineRefund/query")
  },
  {
    name: "onlineRefundSelect",
    path: "/onlineRefundSelect",
    meta: {
      title: "选择退款就诊卡"
    },
    component: () => import("@view/onlineRefund/select")
  },
  {
    name: "onlineRefundNew",
    path: "/onlineRefundNew",
    meta: {
      title: "在线退款（免验证码）"
    },
    component: () => import("@view/onlineRefund/indexNew")
  },
  {
    path: "*",
    redirect: "/404"
  }
];

export default new VueRouter({
  routes
});
